import { useRouter } from 'expo-router';
import type { AnchorHTMLAttributes, MouseEvent } from 'react';

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & { href: string };

// A real <a href> (crawlable, works without JS, middle-click opens a tab) that
// navigates client-side on a plain left click. The pages are styled with CSS
// modules on plain DOM elements, which expo-router's <Link> (a react-native
// Text) can't take a className for.
export function NavLink({ href, onClick, ...rest }: Props) {
  const router = useRouter();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }
    event.preventDefault();
    // Paths are built at runtime (/<locale>/<section>), outside the typed-routes literal set.
    router.push(href as never);
  };

  return <a href={href} onClick={handleClick} {...rest} />;
}
